interface ErrorOption {
    id: string;
    label: string;
    mail_message_nl: string;
    mail_message_fr: string;
    mail_message_en: string;
    mail_message_de: string;
}


const errorOptions: ErrorOption[] = [
    { 
        id: 'image-quality',
        label: 'Poor image quality',
        mail_message_nl: 'De aangeleverde foto is helaas niet duidelijk genoeg voor productherkenning.',
        mail_message_fr: 'La photo fournie n\'est malheureusement pas suffisamment nette pour permettre la reconnaissance du produit.',
        mail_message_en: 'The provided photo is unfortunately not clear enough for product recognition.',
        mail_message_de: 'Das bereitgestellte Foto ist leider nicht klar genug für die Produktidentifikation.'
    },
    { 
        id: 'multiple-parts', 
        label: 'Multiple parts are present in one image', 
        mail_message_nl: 'Er zijn meerdere onderdelen zichtbaar op de foto. Graag per onderdeel een aparte foto aanleveren.',
        mail_message_fr: 'Plusieurs pièces apparaissent sur la photo. Veuillez envoyer une photo distincte pour chaque pièce.',
        mail_message_en: 'Multiple parts are visible in the photo. Please provide a separate photo for each part.',
        mail_message_de: 'Auf dem Foto sind mehrere Teile zu sehen. Bitte senden Sie ein separates Foto für jedes Teil.'
    },
    { 
        id: 'background', 
        label: 'Background is not plain', 
        mail_message_nl: 'De achtergrond van de foto is niet egaal. Graag een foto aanleveren met een egale achtergrond.',
        mail_message_fr: 'L\'arrière- plan de la photo n\'est pas homogène. Veuillez envoyer une photo avec un arrière-plan homogène.',
        mail_message_en: 'The background of the photo is not plain. Please provide a photo with a plain background.',
        mail_message_de: 'Der Hintergrund des Fotos ist nicht einheitlich. Bitte senden Sie ein Foto mit einem einheitlichen Hintergrund.' 
    },
    { 
        id: 'other', 
        label: 'Other (specify below in the customers language)', 
        // No default message for this one, customMessage is used
        mail_message_nl: '',
        mail_message_fr: '',
        mail_message_en: '',
        mail_message_de: ''
    },
];


export default errorOptions;